module.exports = __webpack_public_path__ + "img/pound-sign.4b36cd64.svg";